import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-policy-errors',
  templateUrl: './policy-errors.component.html',
  styleUrls: ['./policy-errors.component.scss']
})
export class PolicyErrorsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
